<template>
  <v-dialog v-model="dialog" persistent max-width="50%">
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar class="toolbar-color">
          <span class="headline ml-2">
            {{
              labelBtn != "Salvar" ? "Editar Permissão" : "Cadastrar Permissão"
            }}
          </span>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col cols="12" sm="12" md="6" lg="6">
              <v-text-field
                label="Permissão"
                v-model="form.descricao"
                :rules="[rules.required]"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6">
              <v-text-field
                label="Router"
                v-model="form.nome"
                :rules="[rules.required]"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6">
              <BaseSelect
                clearable
                single-line
                label="Módulo"
                item-text="modulo"
                item-value="id_modulo"
                service="sistemaService.modulos"
                v-model="form.id_modulo"
                disabled
              />
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="6">
              <BaseSelect
                clearable
                single-line
                label="Menu"
                item-text="descricao"
                item-value="id"
                service="sistemaService.menus"
                v-model="form.id_menu"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="close">Fechar</v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click="
            labelBtn != 'Salvar' ? editarPermissao() : cadastrarPermissao()
          "
          >{{ labelBtn }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from "@/mixins/inputRules";
import sistema from "@/services/http/sistemaService";
import BaseSelect from "@/components/shared/BaseSelectService";
export default {
  name: "ModalCadPermissao",
  components: {
    BaseSelect
  },

  mixins: [rules],

  props: {
    dialog: {
      type: Boolean
    },

    labelBtn: {
      type: String
    },

    editPermissao: {
      type: Object
    }
  },

  data() {
    return {
      form: {}
    };
  },

  watch: {
    editPermissao(value) {
      this.form = value;
    }
  },

  methods: {
    async cadastrarPermissao() {
      const validateStatus = this.$refs.form.validate();

      if (validateStatus) {
        await sistema()
          .permissoes()
          .store(this.form, {
            notification: true,
            message: "Permissão cadastrada com sucesso!"
          });
      }
      this.close();
    },

    async editarPermissao() {
      const validateStatus = this.$refs.form.validate();

      if (validateStatus) {
        await sistema()
          .permissoes(this.form.id_permissao)
          .update(this.form, {
            notification: true,
            message: "Permissao editada com sucesso!"
          });
        this.close();
      }
    },

    close() {
      this.$emit("close");
      this.$refs.form.reset();
    }
  }
};
</script>

<style></style>
